var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Vue, Component, Prop, PropSync, Emit, Watch, } from 'vue-property-decorator';
import ExportationsFields from './Filters/ExportationsFields.vue';
import ExportationsDecisors from './Filters/ExportationsDecisors.vue';
import ExportationsUniqueDecisors from './Filters/ExportationsUniqueDecisors.vue';
import ExportationsCompanyStatus from './Filters/ExportationsCompanyStatus.vue';
import ExportationsLeadStatus from './Filters/ExportationsLeadStatus.vue';
import ExportationsTypes from './Filters/ExportationsTypes.vue';
import BitrixDealConfig from './BitrixDealConfig.vue';
import PiperunOpportunityConfig from './PiperunOpportunityConfig.vue';
import InfosetExportErrorMessage from './InfosetExportErrorMessage.vue';
import { limitSheetAndCRM, exceedLimit } from '@/shared/utils/Infosets.utils';
import { connect } from '@/overmind';
import Tooltip from 'src/components/Tooltip.vue';
import { json } from 'overmind';
import MeetimeCadenceConfig from './MeetimeCadenceConfig.vue';
let InfosetExportContent = class InfosetExportContent extends Vue {
    constructor() {
        super(...arguments);
        this.removeCompaniesAlreadySended = true;
        this.exportTab = 'advanceExportation';
        this.decisors = true;
        this.updateTotvsData = false;
        this.shouldShowStatusPreCRMFilter = true;
        this.loadingEffect = true;
        this.cadenceNameSelected = '';
        this.ownerIdSelected = '';
        this.toggleSaveConfig = false;
        this.showBitrixDealConfig = false;
        this.showPiperunDealConfig = false;
    }
    changedShowPiperunDealConfig(value) {
        if (!value)
            this.changePiperunDealConfig(null);
    }
    changedShowBitrixDealConfig(value) {
        if (!value)
            this.changeBitrixDealConfig(null);
    }
    get maxLimit() {
        const result = limitSheetAndCRM[this.currentTab] || limitSheetAndCRM['default'];
        return result;
    }
    get PhonesNotValid() {
        // 'finished' é o status de validação concluída do fluxo legado;
        // 'completed' é o equivalente escrito pelo atlas-reborn. Sem os dois,
        // uma lista validada pelo reborn mantinha essa opção desabilitada como
        // se nunca tivesse sido validada.
        return !['finished', 'completed'].includes(this.infoset.phonesValidationStatus || '');
    }
    get handlTooltipMsgValidPhoneToggle() {
        return this.PhonesNotValid
            ? 'Essa opção está disponível somente após a validação'
            : 'Vão só os telefones atendidos ou válidos na validação desta lista, e a empresa sem nenhum deles não é exportada. Telefones válidos não consideram contatos de WhatsApp.';
    }
    get ableBitrix24DealToggle() {
        return this.currentTab == 'bitrix24';
    }
    get handleTooltipMsgDealToggle() {
        return this.ableBitrix24DealToggle
            ? 'Ao ativar, as informações da empresa serão integradas à área de negócios, no pipeline e etapa que você configurar'
            : 'Essa opção está disponível somente após a configuração da URL token do Bitrix';
    }
    get handleTooltipMsgPiperunDealToggle() {
        return 'Ao ativar, as informações da empresa serão integradas à área de oportunidades, no pipeline e etapa que você configurar';
    }
    async fetchCompaniesInKanban() {
        // @ts-ignore
        const { data } = await this.effects.api.fetchCompaniesKanbanByStatus({
            infosetId: this.infoset_id,
            status: 'success',
            page: 1,
            query: '',
        });
        if (data && data.length > 0) {
            this.shouldShowStatusPreCRMFilter = true;
        }
        else {
            this.shouldShowStatusPreCRMFilter = false;
        }
        this.loadingEffect = false;
    }
    async mounted() {
        this.decisors = this.filters.decisors || false;
        this.toggleSaveConfig = this.saveConfig;
        await this.fetchCompaniesInKanban();
        if (this.bitrixDealConfig)
            this.showBitrixDealConfig = true;
        if (this.piperunDealConfig)
            this.showPiperunDealConfig = true;
    }
    getcompaniesTotvsExistsCount() {
        //@ts-ignore
        return this.companiesTotvsExistsCount || 0;
    }
    toggleBtnUpdateTotvsData() {
        return {
            updateTotvsData: this.updateTotvsData,
            //@ts-ignore
            companiesCNPJsTotvsExists: json(this.companiesCNPJsTotvsExists),
        };
    }
    exceededCRMLimit() {
        return exceedLimit(this.currentTab, 
        //@ts-ignore
        this.exportStats.companies, 
        //@ts-ignore
        this.exportStats.decisors, this.filters.decisors);
    }
    changedDecisorsFilter(current) {
        this.$emit('changedDecisorsFilter', current);
    }
    changeMeetimeCadenceConfig(value) {
        this.$emit('changeMeetimeCadenceConfig', value);
    }
    changeBitrixDealConfig(value) {
        this.$emit('changeBitrixDealConfig', value);
    }
    changePiperunDealConfig(value) {
        this.$emit('changePiperunDealConfig', value);
    }
    changedOnlyValidPhonesFilter(current) {
        this.$emit('changedOnlyValidPhonesFilter', current);
    }
    emitFields(list) {
        this.$emit('updateFields', list);
    }
    updateCalculate() {
        this.$emit('updateCalculate');
    }
    emitLeads(leadStatus) {
        this.$emit('updateLeads', leadStatus);
    }
    setSaveConfig() {
        this.$emit('setSaveConfig', this.toggleSaveConfig);
    }
    get isSheet() {
        return ['csv', 'excel'].includes(this.currentTab);
    }
    get showDecisorFilters() {
        const sheetCondition = this.exportType == 'decisors' && this.isSheet;
        const crmCondition = this.filters.decisors && !this.isSheet;
        return sheetCondition || crmCondition;
    }
};
__decorate([
    Prop({ default: () => { } })
], InfosetExportContent.prototype, "infoset", void 0);
__decorate([
    Prop({ default: () => { } })
], InfosetExportContent.prototype, "documentType", void 0);
__decorate([
    Prop({ default: () => { } })
], InfosetExportContent.prototype, "currentTab", void 0);
__decorate([
    Prop({ default: false })
], InfosetExportContent.prototype, "disabledToggleSaveFiltersAndFields", void 0);
__decorate([
    Prop({ default: () => { } })
], InfosetExportContent.prototype, "currentFields", void 0);
__decorate([
    Prop({ default: () => false })
], InfosetExportContent.prototype, "saveConfig", void 0);
__decorate([
    PropSync('currentFilters', { default: () => { } })
], InfosetExportContent.prototype, "filters", void 0);
__decorate([
    PropSync('currentService', { default: 'summary' })
], InfosetExportContent.prototype, "service", void 0);
__decorate([
    PropSync('currentType', { default: 'companies' })
], InfosetExportContent.prototype, "exportType", void 0);
__decorate([
    PropSync('keepRedundancy', { default: () => false })
], InfosetExportContent.prototype, "keepDataRedundancy", void 0);
__decorate([
    Prop({ default: false })
], InfosetExportContent.prototype, "calculateCompaniesOnTotvsFetching", void 0);
__decorate([
    Prop({ default: '' })
], InfosetExportContent.prototype, "infoset_id", void 0);
__decorate([
    Prop({ default: 0 })
], InfosetExportContent.prototype, "exportedCnpjForMeetime", void 0);
__decorate([
    PropSync('cacheOnlyValidPhones', { default: () => false })
], InfosetExportContent.prototype, "onlyValidPhones", void 0);
__decorate([
    Prop({ default: () => { } })
], InfosetExportContent.prototype, "bitrixDealConfig", void 0);
__decorate([
    Prop({ default: () => null })
], InfosetExportContent.prototype, "piperunDealConfig", void 0);
__decorate([
    Watch('showPiperunDealConfig')
], InfosetExportContent.prototype, "changedShowPiperunDealConfig", null);
__decorate([
    Watch('showBitrixDealConfig')
], InfosetExportContent.prototype, "changedShowBitrixDealConfig", null);
__decorate([
    Emit('toggleBtnUpdateTotvsData')
], InfosetExportContent.prototype, "toggleBtnUpdateTotvsData", null);
InfosetExportContent = __decorate([
    Component(connect(({ state: { infosets: infosetsState }, effects }) => ({
        exportStats: infosetsState.exportStats,
        companiesTotvsExistsCount: infosetsState.companiesTotvsExistsCount,
        companiesCNPJsTotvsExists: infosetsState.companiesCNPJsTotvsExists,
        effects: effects.companies,
    }), {
        components: {
            ExportationsFields,
            ExportationsDecisors,
            ExportationsUniqueDecisors,
            ExportationsCompanyStatus,
            ExportationsLeadStatus,
            ExportationsTypes,
            BitrixDealConfig,
            PiperunOpportunityConfig,
            InfosetExportErrorMessage,
            Tooltip,
            MeetimeCadenceConfig,
        },
    }))
], InfosetExportContent);
export default InfosetExportContent;
